import { render, staticRenderFns } from "./BadgeTotalization.vue?vue&type=template&id=2ea1ad9a&scoped=true&"
import script from "./BadgeTotalization.vue?vue&type=script&lang=js&"
export * from "./BadgeTotalization.vue?vue&type=script&lang=js&"
import style0 from "./BadgeTotalization.vue?vue&type=style&index=0&id=2ea1ad9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1ad9a",
  null
  
)

export default component.exports